export default __webpack_public_path__ + "static/media/p2p-icon.e68d19c0.png";